import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    
    tarjetasResumenes: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETAS_RESUMENES' (state, tarjetaId) {
        state.tarjetaId = tarjetaId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        
        state.tarjetasResumenes = [];
    },
    'SET_TARJETA' (state, tarjeta) {
        state.banco = tarjeta.banco;
        state.tarjetaMarca = tarjeta.tarjetaMarca;
        state.numeroCuenta = tarjeta.numeroCuenta;
    },
    'SET_TARJETAS_RESUMENES' (state, tarjetasResumenes) {
        state.tarjetasResumenes = tarjetasResumenes.map(tarjetaResumen => ({
            ...tarjetaResumen,
            tarjeta: `${tarjetaResumen.tarjetaMarca} ${tarjetaResumen.tarjetaNumero}`
        }))
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, tarjetaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETAS_RESUMENES', tarjetaId);
            
            if (tarjetaId != 0) {
                apiAxios.get('tarjetas/' + tarjetaId ) 
                .then(res => {
                    commit('SET_TARJETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    getTarjetasResumenes ( { commit, state } ) {
        return new Promise((resolve, reject) => {

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&tarjetaId=' + state.tarjetaId
                + '&sortByDescending=true'; //+ state.sortByDescending;
            
            apiAxios.get('tarjetasresumenes' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TARJETAS_RESUMENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('tarjetasresumenes/tarjeta/' + state.tarjetaId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}